import { render, staticRenderFns } from "./declarationList.vue?vue&type=template&id=41f4028b&scoped=true"
import script from "./declarationList.vue?vue&type=script&lang=js"
export * from "./declarationList.vue?vue&type=script&lang=js"
import style0 from "./declarationList.vue?vue&type=style&index=0&id=41f4028b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f4028b",
  null
  
)

export default component.exports